<crm-sidenav-form-container
  title="{{ title | i18nextCap }}"
  [isDeletable]="isDeletable"
  [formGroup]="newWorkPeriodForm"
  [formFields]="formFields"
  (onSubmit)="createWorkPeriod()"
  (onCancel)="closeNewWorkPeriodEditor()"
></crm-sidenav-form-container>
